import React from 'react';

function renderQuestionAndAnswer(props) {
  return (
    <>
      <span>{props.challenge.prompt}</span>
      { props.challenge.iterables
      && (
        <select
          onChange={({ target }) => props.handleChange({
            prompt: props.challenge.prompt,
            question: props.challenge.iterables[target.selectedIndex],
          })}
        >
          {props.challenge.iterables.map((element) => (
            <option key={element}>{element}</option>
          ))}
        </select>
      )}
      <input
        className="banking-input"
        type="answer"
        id="answer"
        name="answer"
        placeholder="Answer"
        required
        onChange={({ target }) => props.handleChange({
          prompt: props.challenge.prompt,
          question: props.challenge.question
            ? null
            : ((props.challenge.iterables && props.challenge.iterables[0])
              || props.challenge.prompt),
          answer: target.value,
        })}
      />
    </>
  );
}

function renderMultipleChoice(props) {
  return (
    <>
      <span>{props.challenge.prompt}</span>
      {props.challenge.iterables && (
        props.challenge.iterables.map((element, index) => (
          <label key={element} htmlFor={`radio-${index}`}>
            <input
              className="radio-checkbox"
              type="radio"
              tabIndex="0"
              id={`radio-${index}`}
              name="radio"
              value={element}
              onChange={({ target }) => props.handleChange({
                prompt: props.challenge.prompt,
                question: props.challenge.prompt,
                answer: target.value,
              })}
            />
            {element}
          </label>
        ))
      )}
    </>
  );
}

function renderMultipleChoiceMultipleAnswers(props) {
  return (
    <>
      <span>{props.challenge.prompt}</span>
      {props.challenge.iterables.map((element, index) => (
        <label key={element} htmlFor={`check-${index}`}>
          <input
            className="radio-checkbox"
            type="checkbox"
            tabIndex="0"
            name="checkbox"
            id={`check-${index}`}
            value={element}
            onChange={({ target }) => props.handleChange({
              prompt: props.challenge.prompt,
              question: props.challenge.prompt,
              answer: target.checked
                ? [...props.challenge.answer, target.value]
                : props.challenge.answer.filter((answer) => answer !== target.value),
            })}
          />
          {element}
        </label>
      ))}
    </>
  );
}

function renderTextOrCall(props) {
  return (
    <>
      <span>{props.challenge.prompt}</span>
      { props.challenge.iterables.map((element, index) => (
        <div key={element} className="mfa-txtcall">
          <div className="media">
            <div className="media-body media-middle">
              <span className="mfa-text">
                {element}
              </span>
            </div>
            <div className="media-right media-middle">
              <div className="fw">
                <label className="txtcall-btn" htmlFor={`text-${index}`}>
                  <input
                    type="radio"
                    id={`text-${index}`}
                    name="TextOrCall"
                    value="Text"
                    onChange={({ target }) => props.handleChange({
                      prompt: props.challenge.prompt,
                      question: element,
                      answer: target.value,
                    })}
                  />
                  Text
                </label>
                <label className="txtcall-btn" htmlFor={`call-${index}`}>
                  <input
                    type="radio"
                    id={`call-${index}`}
                    name="TextOrCall"
                    value="Call"
                    onChange={({ target }) => props.handleChange({
                      prompt: props.challenge.prompt,
                      question: element,
                      answer: target.value,
                    })}
                  />
                  Call
                </label>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

function renderImageSelection(props) {
  return (
    <>
      <span>{props.challenge.prompt}</span>
      <div className="mood-container">
        {props.challenge.iterables.map((element) => (
          <div
            className="mood-img"
            key={element}
            onClick={() => props.handleChange({
              prompt: props.challenge.prompt,
              answer: element,
              question: props.challenge.prompt,
            })}
            onKeyPress={() => props.handleChange({
              prompt: props.challenge.prompt,
              answer: element,
              question: props.challenge.prompt,
            })}
            role="button"
            tabIndex="0"
          >
            <img src={`data:image/png;base64,${element}`} alt="mood selection" />
          </div>
        ))}
      </div>
    </>
  );
}

// eslint-disable-next-line func-names
export default function (props) {
  switch (props.challenge.type) {
    case 'QuestionAndAnswer':
      return renderQuestionAndAnswer(props);
    case 'MultipleChoice':
      return renderMultipleChoice(props);
    case 'MultipleChoiceMultipleAnswers':
      return renderMultipleChoiceMultipleAnswers(props);
    case 'TextOrCall':
      return renderTextOrCall(props);
    case 'ImageSelection':
      return renderImageSelection(props);
    default:
      return null;
  }
}
